/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_UploadingInputs */

const vi_tea_purchase_payment_proof_uploading = /** @type {(inputs: Tea_Purchase_Payment_Proof_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải ảnh...`)
};

/**

* @param {Tea_Purchase_Payment_Proof_UploadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_uploading = /** @type {((inputs?: Tea_Purchase_Payment_Proof_UploadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_UploadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_uploading(inputs)
});